import { useState } from 'react';

import type { VirtualDirectoryUserFragment } from '../../../../../graphql/api/generated';
import { useDebouncedSearch } from '../../../../../hooks/useDebouncedSearch';

interface IResidentFilters {
  directoryStatus?: string[];
  unlistedReasons?: string[];
}

export function useVirtualDirectoryResidentFilters(residents: VirtualDirectoryUserFragment[]) {
  const { searchWords, onSearch } = useDebouncedSearch();
  const [filters, setFilters] = useState<IResidentFilters>({});

  let filteredResidents = residents;

  if (filters.directoryStatus?.length) {
    filteredResidents = filteredResidents.filter(({ unlistedReasons }) => {
      const directoryStatus = unlistedReasons.length ? 'Unlisted' : 'Listed';

      return !filters.directoryStatus?.length || filters.directoryStatus.includes(directoryStatus);
    });
  }

  if (filters.unlistedReasons?.length) {
    filteredResidents = filteredResidents.filter(resident => (
      resident.unlistedReasons.some(reason => filters.unlistedReasons?.includes(reason))
    ));
  }

  if (searchWords.length) {
    const lowerCaseSearchWords = searchWords.map(s => s.toLowerCase());

    filteredResidents = filteredResidents.filter(({ userFullName, unitDisplayName }) => {
      return lowerCaseSearchWords.every((lowerCaseWord) => {
        return (
          userFullName?.toLowerCase().includes(lowerCaseWord) ||
          unitDisplayName.toLowerCase().includes(lowerCaseWord)
        );
      });
    });
  }

  return {
    onSearch,
    setFilters,
    filteredResidents,
  };
}
